import React from "react";
import store from "../../store";
import {getTopFaqs} from "../../providers/rest";
import Accordion from "react-bootstrap/Accordion";
import Faq from "./Faq";


export default class AllFaq extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            topFaqs: null,
        }
    }

    componentDidMount() {
        store.dispatch(getTopFaqs(6)).then(
            (response) => {
                this.setState({
                    topFaqs: response.value.data.payload
                })
            },
            (error) => {
                console.log('error is ', error)
            })
    }

    render() {
        return <div>
            {this.state.topFaqs !== null ?
                <Accordion defaultActiveKey="0">
                    {
                        this.state.topFaqs.map((topFaq, idx) => {
                            return <Faq key={topFaq.faqId}
                                        evtKey={idx}
                                        topFaq={topFaq}
                            />
                        })
                    }
                </Accordion>
                : null}
        </div>
    }
}
